// src/components/FilterDropdowns.tsx
import React, { useEffect, useState } from 'react';
import { fetchFilterMetadata } from '../utils/fetchFilterMetadata';

interface FilterOption {
  value: string;
  label: string;
  count: number;
}

interface FilterMetadata {
  norm_country: FilterOption[];
  norm_city: FilterOption[];
  norm_job_level: FilterOption[];
  norm_job_function: FilterOption[];
}

interface Props {
  endpointUrl: string;
  jwt: string;
}
interface FilterDropdownsProps extends Props {
  selected: {
    norm_country: string;
    norm_city: string;
    norm_job_level: string;
    norm_job_function: string;
  };
  setSelected: (selected: {
    norm_country: string;
    norm_city: string;
    norm_job_level: string;
    norm_job_function: string;
  }) => void;
}

export const FilterDropdowns: React.FC<FilterDropdownsProps> = ({ endpointUrl, jwt, selected, setSelected }) => {
  const [metadata, setMetadata] = useState<FilterMetadata | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetchFilterMetadata({ endpointUrl, jwt })
      .then((data) => {
        setMetadata(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [endpointUrl, jwt]);

  const handleChange = (filterType: keyof typeof selected, value: string) => {
    setSelected({ ...selected, [filterType]: value });
  };

  if (loading) return <div>Loading filter options...</div>;
  if (error) return <div style={{ color: 'red' }}>Error: {error}</div>;
  if (!metadata) return null;

  return (
    <div>
      {(['norm_country', 'norm_city', 'norm_job_level', 'norm_job_function'] as const).map((filterType) => (
        <div key={filterType} style={{ marginBottom: 16 }}>
          <label htmlFor={filterType} style={{ fontWeight: 'bold' }}>{filterType.replace('norm_', '').replace('_', ' ').toUpperCase()}:</label>
          <select
            id={filterType}
            value={selected[filterType]}
            onChange={(e) => handleChange(filterType, e.target.value)}
            style={{ marginLeft: 8 }}
          >
            <option value="">Select...</option>
            {metadata[filterType].map((option) => (
              <option key={option.value} value={option.value}>
                {option.label} ({option.count})
              </option>
            ))}
          </select>
        </div>
      ))}
    </div>
  );
};
